Bingo.PricePackagesSwitcher = {};
Bingo.PricePackagesSwitcher.type = 'sell';
Bingo.PricePackagesSwitcher.place = 'in';

Bingo.PricePackagesSwitcher.switch = () => {
    const type = Bingo.PricePackagesSwitcher.type;
    const place = Bingo.PricePackagesSwitcher.place;
    const links = $('.js-pricePackagesSwitcherLinks');
    const link = links.attr(`data-link-${type}-${place}`);
    $.nette.ajax({
        type: 'GET',
        url: link,
    });
};
